import { useEffect, useState } from 'react';
import { AccountUsersChangePasswordRequest, AccountUsersChangePasswordResponse } from 'vopay';
import axios from 'axios';
import vopayApi from '@/services/api.config';

const { api } = vopayApi;

export default function useChangePassword() {
  const source = axios.CancelToken.source();
  const [pending, setPending] = useState(false);
  const [response, setResponse] = useState<AccountUsersChangePasswordResponse | null>(null);

  useEffect(() => {
    return () => source.cancel();
  }, []);

  async function changePassword(params: AccountUsersChangePasswordRequest) {
    try {
      setPending(true);
      const res = await api.postAccountUsersChangePassword(params, undefined, source);
      if (!res.Success) {
        throw new Error(res.ErrorMessage);
      }
      setResponse(res);
      return res;
    } finally {
      setPending(false);
    }
  }

  return {
    changePassword,
    pending,
    response,
  };
}
